// Sprint-V25 Issue L (Sa 12.09.2026) — Copy fuer die Landing-Page
// Refactor auf Andreas-Direktive Sa 12.09.2026 Nachmittag:
//   - Away-from-Pain-Trigger statt beobachtender Beschreibung.
//   - Kern-Metapher = Absicht vs. Wirkung (Muster ist nur der Mechanismus).
//   - Gender-neutral: keine „er/sie", „Kollege/Partner" — stattdessen
//     „jemand", „das Gegenueber", „wer".
//   - Konstanter Anker liefert Hoffnung: „Das kannst du aendern."

export const HOOK_COPY = {
  a: {
    headline: ["Du meinst es gut.", "Kommt aber anders an."],
  },
  b: {
    headline: ["Nach dem Gespräch bist du leer.", "Und weißt nicht, warum."],
  },
  c: {
    headline: ["Am Ende zweifelst du an dir.", "Dabei hast du es nur gut gemeint."],
  },
  d: {
    headline: ["Ein Satz — und die Stimmung kippt.", "Wieder."],
  },
};

// Headline-Kandidaten (INAKTIV). Nur in der Vorschau per ?hook=q01..q10 sichtbar.
// IDs fest an genau einen Text gebunden; Quelle wird separat erfasst.
export const HEADLINE_CANDIDATES = {
  q01: { headline: ["Du sagst einen Satz.", "Warum hört dein Gegenüber etwas anderes?"] },
  q02: { headline: ["Wenn du es zum dritten Mal erklärst,", "was fehlt dann wirklich?"] },
  q03: { headline: ["Zehn Jahre.", "So lange kann ein Kommunikationsmuster nachwirken."] },
  q04: { headline: ["Ein Missverständnis am Morgen.", "Schlechte Stimmung bis abends?"] },
  q05: { headline: ["Je mehr du erklärst,", "desto größer wird manchmal der Abstand."] },
  q06: { headline: ["Du erklärst es glasklar.", "Und trotzdem kommt etwas anderes an."] },
  q07: { headline: ["Du sagst es ganz harmlos.", "Und plötzlich ist Drama."] },
  q08: { headline: ["Vielleicht liegt es nicht daran,", "dass du dich falsch ausdrückst."] },
  q09: { headline: ["5 Fragen.", "Ein Muster, das du bisher übersehen hast."] },
  q10: { headline: ["Kommunikation scheitert nicht immer am Gesagten.", "Sondern am Gehörten."] },
};

// Konstanter Anker unter der Hero-Headline. Traegt die Diagnose („Absicht
// ist nicht Wirkung.") und den Hoffnungs-Ausblick („Das kannst du aendern.")
// zusammen — Away-from-Pain wird zum Away-to-Solution.
export const HOOK_ANCHOR = {
  first: "Absicht ist nicht Wirkung.",
  second: "Das kannst du ändern.",
};

// Vier Fokustypen — es gibt ZWEI festgeschriebene Ordnungen (Andreas-Direktive
// Sa 12.09.2026 09:35), je nach Layout:
//
//   FOKUSTYPEN_SEQUENCE  (1-Reihe / 4×1 Row):  Katze · Eule · Biene · Hund
//   FOKUSTYPEN_GRID      (Kachel / 2×2):
//                        Oben-Links=Katze   Oben-Rechts=Eule
//                        Unten-Links=Hund   Unten-Rechts=Biene
//   → In row-major-Order (wie CSS grid-cols-2 rendert):
//     [Katze, Eule, Hund, Biene]
//
// Die Metadaten (label, motto) leben in einem gemeinsamen Lookup, damit die
// Arrays nur die Reihenfolge tragen.
// Mottos richten sich nach den offiziellen Erkennungsmerkmalen in
// /app/frontend/src/data/fokustypErkennungsmerkmale.js.
// Sprint-V25 Issue L Finalisierung (Sa 12.09.2026 spät, Boardroom-CoS):
//   - Hund:   hilfsbereit · fürsorglich  (vorher „loyal · direkt" — „direkt"
//             kollidierte mit Katze; „loyal" ist implizit, nicht Kern.)
//   - Katze:  impulsiv · spontan  (bereits korrekt).
//   - Biene:  strukturiert · gewissenhaft  (vorher „verbindlich · fürsorglich"
//             — „fürsorglich" kollidierte mit Hund; „strukturiert" trifft den
//             Kern der Biene aus FT_ERKENNUNGSMERKMALE.biene präziser.)
//   - Eule:   beobachtend · analytisch  (bereits korrekt).
const FOKUSTYP_META = {
  katze: { key: "katze", label: "Katze", motto: "impulsiv · spontan" },
  eule: { key: "eule", label: "Eule", motto: "beobachtend · analytisch" },
  biene: { key: "biene", label: "Biene", motto: "strukturiert · gewissenhaft" },
  hund: { key: "hund", label: "Hund", motto: "hilfsbereit · fürsorglich" },
};
export const FOKUSTYPEN_SEQUENCE = [
  FOKUSTYP_META.katze,
  FOKUSTYP_META.eule,
  FOKUSTYP_META.biene,
  FOKUSTYP_META.hund,
];
export const FOKUSTYPEN_GRID = [
  FOKUSTYP_META.katze,
  FOKUSTYP_META.eule,
  FOKUSTYP_META.hund,
  FOKUSTYP_META.biene,
];
// Rueckwaerts-Kompatibilitaet — Default-Import bleibt der Sequence-Array.
export const FOKUSTYPEN = FOKUSTYPEN_SEQUENCE;

// Drei Benefit-Punkte fuer die Offer-Section.
// Sprint-V25 Issue L Hotfix (Sa 12.09.2026 09:15) — Andreas-Direktive:
// „Kein Account" raus, „Kein Follow-up-Mail-Ping-Pong" raus (das waeren
// Falschversprechen, weil der Magic-Link genau ein Follow-up-Mail ist).
// Stattdessen: was der User TATSAECHLICH bekommt — Aha-Moment, Spiegel,
// Fahrplan.
export const OFFER_FEATURES = [
  {
    icon: "sparkles",
    title: "Erster Aha-Moment",
    body: "Du siehst dich zum ersten Mal von außen.",
  },
  {
    icon: "eye",
    title: "Ehrlicher Spiegel",
    body: "Du erkennst, warum manche dich anders verstehen.",
  },
  {
    icon: "compass",
    title: "Code entschlüsselt",
    body: "Du weißt danach, was du morgen anders machst.",
  },
];

export const CTA_LABEL = "Meinen Code entschlüsseln →";
